import * as api from "./api";
import { trackGoogleEvent } from "./googleAnalytics";

const EVENTS_ENDPOINT = "/api/marketing/events";
const EVENTS_ENABLED = process.env.NEXT_PUBLIC_ENABLE_MARKETING_EVENTS === "true";

interface TrackOptions {
  fireAndForget?: boolean;
}

function safeToken() {
  return localStorage.getItem("token") || "";
}

export function track(name: string, properties?: Record<string, unknown>, options?: TrackOptions) {
  if (!EVENTS_ENABLED) return;

  const doNotTrack =
    (typeof navigator !== "undefined" && (navigator.doNotTrack === "1" || (navigator as any).msDoNotTrack === "1")) ||
    (typeof window !== "undefined" && (window as any).doNotTrack === "1");
  if (doNotTrack) return;

  trackGoogleEvent(name, properties);

  const payload = {
    name,
    properties: {
      ...properties,
      path: window.location.pathname,
      ts: new Date().toISOString(),
    },
  };

  if (options?.fireAndForget !== false && navigator.sendBeacon) {
    try {
      const body = JSON.stringify(payload);
      const blob = new Blob([body], { type: "application/json" });
      const queued = navigator.sendBeacon(EVENTS_ENDPOINT, blob);
      if (queued) return;
    } catch {
      // Ignore beacon transport issues in privacy-restricted clients.
    }
  }

  api.trackEvent(payload).catch(() => {
    // Telemetry should never block the user journey.
  });
}

export function trackAuthed(name: string, properties?: Record<string, unknown>) {
  track(name, {
    ...properties,
    hasToken: Boolean(safeToken()),
  });
}
